export const schoolInfo = {
  name: "St Lord's International Public School, Bangalore",
  shortName: "St Lord's International Public School",
  addressLines: [
    "#19/1, 19th Cross Road",
    "3rd Main Road",
    "Bhuvaneshwari Nagar, Binnipete",
    "Kempapura Agrahara",
    "Bangalore - 560023, Karnataka, India",
  ],
  phone: "8884875487",
  email: "shree.slips@gmail.com",
  boards: ["CBSE", "ICSE", "State Board"],
  schoolTypes: [
    "Primary School",
    "Middle School",
    "High School",
  ],
  management: "Private School",
};

export const navItems = [
  { label: "About", id: "about" },
  { label: "Academics", id: "academics" },
  { label: "Campus Life", id: "facilities" },
  { label: "Gallery", id: "gallery" },
  { label: "Admissions", id: "admissions" },
  { label: "Contact", id: "contact" },
];

export const heroSlides = [
  {
    title: "A safe and happy place where children can learn, grow and build a bright future.",
    description:
      "With good teaching, smart learning and fun activities, we help students learn well, build confidence and enjoy their school years.",
    badge: "Admissions Open 2026-27",
    image: "/hero-section/school-img.png",
  },
  {
    title: "A safe, friendly and happy place where children can learn, play and grow.",
    description:
      "Students learn through classroom lessons, fun activities, sports and creative work. We help every child build confidence, learn new things and become a better person.",
    badge: "Holistic Education",
    image: "/hero-section/childrens-1.png",
  },
  {
    title: "We use smart classrooms and technology to make learning easy and fun.",
    description:
      "Students learn through videos, activities and interactive lessons. This helps them understand better, stay interested and learn with confidence.",
    badge: "Smart Learning",
    image: "/hero-section/childrens-2.png",
  },
];

export const heroHighlights = [
  { value: "4", label: "Learning Stages: From early years to higher classes" },
  { value: "2", label: "Academic Pathways: CBSE and State Board" },
  { value: "360", label: "Growing Minds Through Learning, Arts and Values" },
  { value: "1", label: "Child-First Approach: A safe and happy place for every child" },
];

export const aboutPoints = [
  "A safe and friendly place where children feel happy and supported.",
  "Children learn through studies, sports, art, activities and fun.",
  "We help children build confidence, good habits and useful skills.",
];

export const chooseCards = [
  {
    title: "Good Education",
    description:
      "Simple and clear teaching helps children understand their lessons and build strong basics.",
  },
  {
    title: "Smart Learning",
    description:
      "Smart classrooms and digital tools make learning easy and interesting.",
  },
  {
    title: "Modern Labs",
    description:
      "Science and computer labs give students a chance to learn by doing and try new things.",
  },
  {
    title: "Fun Activities",
    description:
      "Art, music, sports, storytelling and other activities help children find what they enjoy.",
  },
  {
    title: "Safe & Caring School",
    description:
      "A safe and friendly place where children are cared for and supported.",
  },
  {
    title: "Parents & School Together",
    description:
      "Regular communication keeps parents updated about their child’s learning and progress.",
  },
];

export const academicCards = [
  {
    title: "Academic Excellence",
    description:
      "Clear concepts, regular practice, simple assessments and personal attention help students learn with confidence.",
    tags: ["Easy concept learning", "Regular practice", "Student progress"],
  },
  {
    title: "Smart Classrooms",
    description:
      " Interactive classes make learning simple, engaging and easy to understand.",
    tags: ["Visual learning", "Interactive classes", "Group activities"],
  },
  {
    title: "Digital Learning Features",
    description:
      "Technology-based learning helps students build digital skills and understand lessons in a simple and engaging way.",
    tags: ["Digital lessons", "Multimedia learning", "Technology skills"],
  },
];

export const facilityCards = [
  {
    title: "Bright Classrooms",
    description:
      "Comfortable classrooms create a positive space for learning. Students can focus, interact and learn with confidence.",
  },
  {
    title: "Library & Reading Corners",
    description:
      "A quiet and welcoming space encourages students to enjoy reading. Books help build knowledge, imagination and good reading habits.",
  },
  {
    title: "Science & Activity Labs",
    description:
      "Hands-on activities make learning more interesting and practical. Students learn by exploring, observing and trying new things.",
  },
  {
    title: "Creative Arts Zones",
    description:
      "Creative spaces give students the freedom to express their ideas. Art, music and activities help build creativity and confidence.",
  },
];

export const sportsCards = [
  {
    title: "Sports & Physical Education",
    description:
      "Regular sports and physical activities keep students active and healthy. Team games also teach discipline, teamwork and sportsmanship.",
  },
  {
    title: "Co-curricular Activities",
    description:
      "Clubs and school activities help students discover their interests and talents. They also build confidence, creativity and teamwork.",
  },
  {
    title: "Achievements & Recognition",
    description:
      "Students are encouraged to take part, try new things and do their best. Their efforts and achievements are appreciated and celebrated.",
  },
];

export const showcaseSlides = [
  {
    title: "Interactive classrooms",
    caption: "Fun and engaging lessons that encourage students to take part and learn with interest.",
    image: "/illustrations/classroom-learning.png",
  },
  {
    title: "Creative exploration",
    caption: "Activities that help students express their ideas, discover talents and build confidence.",
    image: "/illustrations/art-activity.png",
  },
  {
    title: "Digital readiness",
    caption: "Simple technology-based learning helps students develop useful digital skills for the future.",
    image: "/illustrations/faculty-guidance.png",
  },
];

export const stats = [
  { value: 4, suffix: "", label: "From early learning to higher classes, students grow through every stage." },
  { value: 2, suffix: "", label: "Different academic options give families flexibility in choosing what suits their child." },
  { value: 100, suffix: "%", label: "Every student receives guidance, care and support for their overall growth." },
  { value: 360, suffix: "°", label: "We focus on academics, creativity, character, confidence and life skills." },
];

export const achievements = [
  {
    title: "Student Recognition",
    description:
      "We appreciate students for their achievements, efforts and participation in different activities.",
  },
  {
    title: "Confidence-Building Activities",
    description:
      "Assemblies, performances and competitions give students opportunities to express themselves.",
  },
  {
    title: "Student Growth",
    description:
      "Teachers guide and encourage students to learn, improve and become more confident.",
  },
];

export const galleryImages = [
  {
    title: "Morning classroom energy",
    image: "/illustrations/classroom-learning.png",
  },
  {
    title: "Collaborative learning",
    image: "/illustrations/faculty-guidance.png",
  },
  {
    title: "Creative lab moments",
    image: "/illustrations/art-activity.png",
  },
  {
    title: "Reading and reflection",
    image: "/illustrations/reading-library.png",
  },
  {
    title: "Art and expression",
    image: "/illustrations/sports-activity.png",
  },
  {
    title: "Celebration and community",
    image: "/illustrations/school-campus.png",
  },
];

export const testimonials = [
  {
    name: "Parent Voice",
    quote:
      "My child really likes the school. The teachers are very nice and helpful. We are happy with how our child is doing.",
  },
  {
    name: "Primary Parent",
    quote:
      "My child really enjoys the sports and school activities. They always come home and tell us about what they did that day. We are happy to see them enjoying school.",
  },
  {
    name: "Senior School Family",
    quote:
      "Earlier my child was not very confident about exams. Now they prepare better and feel more comfortable. The teachers give good practice and help whenever they have doubts. We are happy with that.",
  },
];

export const facultyHighlights = [
  {
    title: "Supportive Teaching",
    description:
      "Teachers help students understand lessons and are there to guide them when needed.",
  },
  {
    title: "Clear Learning",
    description:
      "Teachers explain topics in a simple way and help students improve their understanding.",
  },
  {
    title: "Life Skills",
    description:
      "Teachers encourage students to be responsible, confident and respectful in everyday life.",
  },
  {
    title: "Parent Support",
    description:
      "Teachers and parents work together to support the child's learning and progress.",
  },
];

export const timelineEvents = [
  {
    period: "June",
    title: "New Academic Year",
    description:
      "Students begin the new year, meet their teachers and settle into their classes.",
  },
  {
    period: "August",
    title: "Learning & Activities",
    description:
      "Students take part in projects, activities and classroom events.",
  },
  {
    period: "November",
    title: "Sports & Cultural Events",
    description:
      "Students enjoy sports, arts and school events while taking part with their friends.",
  },
  {
    period: "January",
    title: "Review & Preparation",
    description:
      "Students review their learning, prepare for exams and set new goals.",
  },
];

export const missionCards = [
  {
    title: "Our Vision",
    description:
      "To help every child become confident, responsible and ready for the future through good education and a caring school environment.",
  },
  {
    title: "Our Mission",
    description:
      "To provide quality learning, good values and activities that help students learn, grow and discover their talents.",
  },
  {
    title: "Our Core Promise",
    description:
      "We support every child in academics, confidence, good habits, communication and overall growth.",
  },
];

export const safetyCards = [
  {
    title: "Transportation Awareness",
    description:
      "Thoughtful commute coordination and family-first planning support peace of mind during daily travel.",
  },
  {
    title: "Campus Safety Practices",
    description:
      "Supervision, structured routines and attentive staff help maintain a secure learning environment.",
  },
  {
    title: "Wellbeing-first Culture",
    description:
      "Students are encouraged to speak up, stay connected and learn in a calm, respectful atmosphere.",
  },
];

export const contactQuickFacts = [
  "Choose from CBSE and State Board education options.",
  "Classes are available from primary level to higher secondary.",
  "A private school focused on quality education and student growth.",
  "Our team is available to answer parent questions and provide guidance.",
];
